import { IUndergroundInfoSchema } from '@cian/api-models/offer-card/v1/get-offer-data';

export type TUndergrounds = IUndergroundInfoSchema[] | null;

/**
 * Возвращает true, если были выбраны станции метро.
 */
export function isSubwayAdded(undergrounds: TUndergrounds): boolean {
  return undergrounds !== null && Object.keys(undergrounds).length > 0;
}
